<template>
  <page :title="$tc('slider._name')">
    <div class="box">
      <b-table :data="sliders.data">
        <template slot-scope="props">
          <b-table-column label="Slider">
            <router-link
              :to="'/marketing/sliders/' + props.row.id"
            >{{ props.row.name ? props.row.name : "-" }}</router-link>
          </b-table-column>

          <b-table-column label="Slug">{{ props.row.key }}</b-table-column>

          <b-table-column>
            <div class="is-pulled-right">
              <router-link class="button" :to="`/marketing/sliders/${props.row.id}`">Edit</router-link>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      sliders: new window.RemoteCollection(
        "/admin/api/marketing/sliders"
      ).load()
    };
  }
};
</script>
